import { Component, inject } from '@angular/core';
import { ModalRef } from '../../modal/modal-ref';
import { ModalConfig } from '../../modal/modal-config';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NgForm, FormsModule } from '@angular/forms';
import { NgStyle, AsyncPipe } from '@angular/common';
import { resizeImage } from '../../image-resize.util';
import { StorageImage } from '../../storage-images.util';
import { StorageImageService } from '../../storage-image.service';
import { ImagePickerComponent } from '../../image-picker/image-picker.component';

@Component({
  selector: 'app-add-gallery',
  templateUrl: './add-gallery.component.html',
  styleUrls: ['./add-gallery.component.scss'],
  imports: [FormsModule, NgStyle, AsyncPipe, ImagePickerComponent]
})
export class AddGalleryComponent {
  private modal = inject(ModalRef);
  config = inject(ModalConfig);
  private storage = inject(AngularFireStorage);
  private storageImages = inject(StorageImageService);

  public inputData;
  uploadedImage: File;
  images: StorageImage[] = [];
  selectedImages = new Set<StorageImage>();

  get selectedPaths(): string[] {
    return Array.from(this.selectedImages).map(img => img.path);
  }
  public formData = { title: '', content: '', bg: '', fileLink: '', imageIsFile: true, gallery: true, order: 0 };

  private id;

  constructor() {
    this.inputData = this.config.data;
    this.getSavedImages();
    if (this.inputData.content?.id) {
      this.formData = this.inputData.content.attributes;
      this.id = this.inputData.content.id;
    }
  }

  addImage(event) {
    const file = event.target.files[0];
    const filePath = 'user-images/' + file.name;

    resizeImage(file, 720, 500).then(resized => {
      this.uploadedImage = resized;
      this.storage.upload(filePath, this.uploadedImage).then(() => {
        this.getSavedImages();
      });
    });
  }

  onAddArticle(formData: NgForm) {
    const formAttributes = formData.form.value;
    formAttributes.images = Array.from(this.selectedImages).map(img => img.path);
    formAttributes.gallery = true;
    const data = {type: this.inputData.type, attributes: formAttributes, id: this.id};
    this.modal.close(data);
  }

  getSavedImages() {
    // Preserve the current selection across refreshes (upload/delete); fall
    // back to the images the article was originally saved with on first load.
    const selectedPaths: string[] = this.selectedImages.size
      ? this.selectedPaths
      : this.inputData.content?.attributes?.images ?? [];
    this.storageImages.listSavedImages().then(images => {
      this.images = images;
      this.selectedImages = new Set(images.filter(img => selectedPaths.includes(img.path)));
    }).catch(error => console.log(error));
  }

  selectImage(img: StorageImage) {
    this.selectedImages.add(img);
  }

  removeImage(img: StorageImage) {
    this.selectedImages.delete(img);
  }

  onImageDeleted(img: StorageImage) {
    this.selectedImages.delete(img);
    this.getSavedImages();
  }
}
